

import React from "react"
import { useState, useEffect } from "react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import DeleteModal from "../DeleteModal"
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  useDroppable,
} from "@dnd-kit/core"
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import {
  Accordion,
  Badge,
  Button,
  Dropdown,
  Modal,
  Form,
  Col,
} from "react-bootstrap"
import Select from "react-select"
import { BsThreeDotsVertical, BsGripVertical, BsTrash } from "react-icons/bs"
import { FaLinkedinIn, FaPlus, FaSortAlphaDown } from "react-icons/fa"
import { useGetRequest, usePostRequest } from "../../Utils/hooks/QueryHandler"
import useLocalStorageState from "use-local-storage-state"
import { toast } from "sonner"
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler"
import { RxCross2 } from "react-icons/rx"
import { IoCheckmark } from "react-icons/io5"
import { customStyles } from "../../Utils/helpers/commonhelper"
// Static data for default fields (these are system predefined fields)
const defaultFields = [
  {
    name: "Salutation",
    type: "Single-Option",
    icon: "🔽",
    description: "Field for select salutation type",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
  },
  {
    name: "Firstname",
    type: "Text",
    description: "Field for First Name",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Lastname",
    type: "Text",
    icon: "abc",
    description: "Field for Last Name",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Contact Owner",
    type: "Single-Option",
    icon: "🔽",
    description: "Field for select Contact Owner",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Report To",
    type: "Text",
    icon: "abc",
    description: "-",
    imp: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
    req: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
  },
  {
    name: "Contact",
    type: "Phone",
    icon: "123",
    description: "Field for add contact number",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Email",
    type: "Email",
    icon: "abc",
    description: "Field for select input email",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Select Timezone",
    type: "Single-Option",
    icon: "🔽",
    description: "Field to select time-zone",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Address",
    type: "Large Text",
    icon: "abc",
    description: "Field for add address",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  // {
  //   name: "Visible to",
  //   type: "Single-Option",
  //   icon:"🔽",
  //   description: "-",
  //   imp: (
  //     <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
  //   ),
  //   req: (
  //     <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
  //   ),
  // },
  {
    name: "State",
    type: "Single-Option",
    icon: "🔽",
    description: "Field for select state",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "City",
    type: "Single-Option",
    icon: "🔽",
    description: "Field for add feedback ",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Zip",
    type: "Text",
    icon: "abc",
    description: "Field for add area zip code ",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "FaceBook",
    type: "Text",
    icon: "FB",
    description: "Field for add your facebook url",
    imp: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
    req: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
  },
  {
    name: "Linkedin",
    type: "Text",
    icon: <FaLinkedinIn />,
    description: "Field for add your linkedin url",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Instagram",
    type: "Text",
    icon: "@",
    description: "Field for add your Insta url",
    imp: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
    req: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
  },
  {
    name: "Twitter",
    type: "Text",
    icon: "#",
    description: "Field for add your Twitter url",
    imp: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
    req: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
  },
  {
    name: "department",
    type: "Text",
    icon: "abc",
    description: "Field for add department ",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Designation",
    type: "Text",
    icon: "abc",
    description: "Field for add designation ",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Decision Maker",
    type: "Toggle ",
    icon: "||",
    description: "Field for add feedback ",
    imp: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
    req: <RxCross2 style={{ width: "20px", height: "20px", color: "red" }} />,
  },
  {
    name: "Lead Source",
    type: "Single-Option",
    icon: "🔽",
    description: "Field for add lead source ",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Tags",
    type: "Multiple-Option",
    icon: "🔽",
    description: "Field for add tags ",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
  {
    name: "Notes",
    type: "Text",
    icon: "abc",
    description: "Field for add note",
    imp: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
    req: (
      <IoCheckmark style={{ width: "25px", height: "25px", color: "green" }} />
    ),
  },
]

// Available field types for dropdown selection
const fieldTypes = [
  { value: "text", label: "Text" },
  { value: "largeText", label: "Large Text" },
  { value: "single-option", label: "Single Option" },
  { value: "multiple-option", label: "Multiple Options" },

  { value: "numerical", label: "Numerical" },
  { value: "monetary", label: "Monetary" },
  { value: "user", label: "User" },
  { value: "company", label: "Company" },

  { value: "phone", label: "Phone" },
  { value: "time", label: "Time" },
  { value: "time-range", label: "Time range" },
  { value: "date", label: "Date" },
  { value: "date range", label: "Date-Range" },
  { value: "address", label: "Address" },
]

// NEW: Draggable Option Item Component
const DraggableOptionItem = ({
  option,
  index,
  onUpdate,
  onRemove,
  fieldType,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `option-${index}`,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="d-flex gap-2 mb-2 align-items-center"
    >
      {/* Drag handle */}
      <div
        {...attributes}
        {...listeners}
        style={{
          cursor: "grab",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4px",
        }}
      >
        <BsGripVertical className="text-muted" />
      </div>
      {/* Equal sign for Multiple Options */}
      {fieldType === "multiple-option" && (
        <span className="text-muted" style={{ minWidth: "20px" }}>
          =
        </span>
      )}
      {/* Option input */}
      <Form.Control
        className="form-control custom-min-height"
        type="text"
        value={option.option}
        onChange={(e) => onUpdate(index, e.target.value)}
        placeholder={`Option ${index + 1}`}
      />
      {/* Delete button */}
      <Button
        variant="outline-danger"
        size="sm"
        onClick={() => onRemove(index)}
      >
        <BsTrash />
      </Button>
    </div>
  )
}

// Component for drag-and-drop area when group is empty - ENHANCED MESSAGE
const DroppableGroupArea = ({ groupName, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: `group-${groupName}`,
  })

  return (
    <div
      ref={setNodeRef}
      style={{
        minHeight: children ? "auto" : "80px",
        backgroundColor: isOver ? "#f8f9fa" : "transparent",
        border: isOver
          ? "2px dashed #007bff"
          : children
            ? "none"
            : "1px dashed #dee2e6",
        borderRadius: "4px",
        transition: "all 0.2s ease",
        padding: children ? "0" : "10px",
      }}
    >
      {children || (
        <div className="text-center py-3 text-muted">
          <div className="mb-2">
            📁 <strong>{groupName}</strong> group
          </div>
          <small>Drop fields here or add new fields to this group</small>
        </div>
      )}
    </div>
  )
}

// Draggable table row component for flat view
const DraggableTableRow = ({
  field,
  canDrag,
  index,
  onEditField,
  onDeleteField,
  allFields,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: field.id, disabled: !canDrag })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <tr ref={setNodeRef} style={style}>
      {/* Drag handle */}
      <td style={{ width: "30px", padding: "8px" }}>
        <div
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px",
          }}
        >
          <BsGripVertical className="text-muted" />
        </div>
      </td>
      {/* Field name with icon */}
      <td>
        <div className="d-flex align-items-center gap-2">
          <span
            className="px-2 py-1 border rounded bg-light text-muted"
            style={{
              fontSize: "0.8rem",
              minWidth: "32px",
              textAlign: "center",
            }}
          >
            {field.icon || "🛠️"}
          </span>
          <div>
            <div>{field.fieldName || field.label_name}</div>
            <div className="text-muted small">
              {field.fieldType || field.label_type}
            </div>
          </div>
        </div>
      </td>
      {/* Description */}
      <td className="text-center">
        {field.description && field.description.trim() !== ""
          ? field.description
          : "-"}
      </td>
      {/* Actions dropdown */}
      <td className="text-end">
        <Dropdown align="end">
          <Dropdown.Toggle
            as={BsThreeDotsVertical}
            className="text-muted"
            style={{ cursor: "pointer" }}
          />
          <Dropdown.Menu
            style={{
              zIndex: 9999, // Even higher z-index for the menu
              position: "absolute",
              right: 0,
              // top: "100%",
            }}
          >
            <Dropdown.Item
              onClick={() => onEditField(field, allFields.indexOf(field))}

            >
              Edit
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onDeleteField(field)}>
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  )
}

// Draggable table row component for grouped view - ENHANCED WITH QUALITY RULES STYLING
const DraggableGroupRow = ({
  field,
  index,
  onEditField,
  onDeleteField,
  allFields,
  logQualityRules,
  canDrag,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: field.id, disabled: !canDrag })

  React.useEffect(() => {
    logQualityRules(field, "DraggableGroupRow render")
  }, [field, logQualityRules])

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <tr ref={setNodeRef} style={style}>
      {/* Drag handle */}
      <td style={{ width: "30px", padding: "8px" }}>
        <div
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px",
          }}
        >
          <BsGripVertical className="text-muted" />
        </div>
      </td>
      {/* Field name with icon */}
      <td>
        <div className="d-flex align-items-center gap-2">
          <span
            className="px-2 py-1 border rounded bg-light text-muted"
            style={{
              fontSize: "0.8rem",
              minWidth: "32px",
              textAlign: "center",
            }}
          >
            {field.icon || "🛠️"}
          </span>
          <div>
            <div>{field.fieldName || field.label_name}</div>
            <div className="text-muted small">
              {field.fieldType || field.label_type}
            </div>
          </div>
        </div>
      </td>
      {/* Description */}
      <td className="text-center">
        {field.description && field.description.trim() !== ""
          ? field.description
          : "-"}
      </td>
      {/* Quality Rules with styling */}
      <td className="text-center">
        <div className="d-flex align-items-center flex-column gap-1">
          {/* Required Status Badge */}
          <div
            className={
              field.required || field.is_required === "yes"
                ? "badge rounded-pill bg-success"
                : "badge rounded-pill bg-danger"
            }
          >
            {field.required || field.is_required === "yes"
              ? "Required"
              : "Not Required"}
          </div>
          {/* Important Status Badge */}
          <div
            className={
              field.important || field.is_important === "yes"
                ? "badge rounded-pill bg-success"
                : "badge rounded-pill bg-danger"
            }
          >
            {field.important || field.is_important === "yes"
              ? "Important"
              : "Not Important"}
          </div>
        </div>
      </td>
      {/* Actions dropdown */}
      <td className="text-end">
        <Dropdown>
          <Dropdown.Toggle
            as={BsThreeDotsVertical}
            className="text-muted"
            style={{ cursor: "pointer" }}

          />
          <Dropdown.Menu
            style={{
              position: "absolute",
              right: 0,
              // top: "100%",
            }}

          >
            <Dropdown.Item
              onClick={() => onEditField(field, allFields.indexOf(field))}
            >
              Edit
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onDeleteField(field)}>
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  )
}

const ContactFields = ({ moduleType = "contact" }) => {
  // UI State Management
  const [viewMode, setViewMode] = useState("grouped")
  const [showModal, setShowModal] = useState(false)
  const [selectedGroup, setSelectedGroup] = useState(null)
  const [isAddingGroup, setIsAddingGroup] = useState(false)
  const [newGroupName, setNewGroupName] = useState("")
  const [editingFieldIndex, setEditingFieldIndex] = useState(null)
  const [editingGroup, setEditingGroup] = useState(null)
  const [editedName, setEditedName] = useState("")
  const [customizedFieldId, setCustomizedFieldId] = useState("")
  const [isEditMode, setIsEditMode] = useState(false) // FIXED: Removed circular reference
  const [loadingFieldDetails, setLoadingFieldDetails] = useState(false)
  const [openGroupDropdown, setOpenGroupDropdown] = useState(null)
  // delete modal loading state
  const [isLoading, setIsLoading] = useState(false)

  // Field Sequence State Management
  const [fieldSequence, setFieldSequence] = useState({})

  // ACCORDION STATE
  const [activeAccordionKeys, setActiveAccordionKeys] = useState([
    "0",
    "1",
    "2",
  ])
  const [nestedAccordionKeys, setNestedAccordionKeys] = useState([])

  // Field Form State
  const [required, setRequired] = useState(false)
  const [important, setImportant] = useState(false)
  const [showDescription, setShowDescription] = useState(false)
  const [description, setDescription] = useState("")
  const [sequence, setSequence] = useState("")

  // Enhanced Options State
  const [fieldOptions, setFieldOptions] = useState([])
  const [newOption, setNewOption] = useState("")
  const [selectedFieldType, setSelectedFieldType] = useState("")
  const [selectedFieldTypeOption, setSelectedFieldTypeOption] = useState(null)

  // Data State
  const [groups, setGroups] = useState([])
  const [allFields, setAllFields] = useState([])
  const [loadingFields, setLoadingFields] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showDeleteModal1, setShowDeleteModal1] = useState(false)
  const [FieldToDelete, setFieldToDelete] = useState(null)
  const [GroupToDelete, setGroupToDelete] = useState(null)

  // Form handling
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = useForm()

  // Watch field type changes
  // const watchedFieldType = watch("fieldType"))

  // Update selected field type when form field changes
  // useEffect(() => {
  //   setSelectedFieldType(watchedFieldType || "")
  //   // Clear options when field type changes to non-option types
  //   if (watchedFieldType && !["Single-Option", "Multiple-Option"].includes(watchedFieldType)) {
  //     setFieldOptions([])
  //   }
  // }, [watchedFieldType])

  useEffect(() => {
    // Clear options when field type changes to non-option types
    if (
      selectedFieldType &&
      !["single-option", "multiple-option"].includes(selectedFieldType)
    ) {
      setFieldOptions([])
    }
  }, [selectedFieldType])

  // Session and navigation
  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  })
  const navigate = useNavigate()

  // API configuration
  const customerId = customer?.customer_details?.customer_id
  const loginUserId = customer?.customer_details?.id
  const token = customer?.token?.authorization
  const rf = customer?.token?.authentication
  const headers = { authentication: rf, Authorization: token }
  const extras = { customer, setCustomer, rf, navigate }

  const permission = customer.customer_details?.permission
  const settingPermision = permission?.filter(
    (c) => c.module_name === "setting"
  )
  const user_type = Number(customer.customer_details?.user_type)
  const preferenceGrant = {
    isView:
      user_type !== 1
        ? Boolean(
          Number(
            settingPermision?.find((c) => c.feature_name === "preference")
              ?.view
          )
        )
        : true,
    isCreate:
      user_type !== 1
        ? Boolean(
          Number(
            settingPermision?.find((c) => c.feature_name === "preference")
              ?.create
          )
        )
        : true,
    isEdit:
      user_type !== 1
        ? Boolean(
          Number(
            settingPermision?.find((c) => c.feature_name === "preference")
              ?.edit
          )
        )
        : true,
    isDelete:
      user_type !== 1
        ? Boolean(
          Number(
            settingPermision?.find((c) => c.feature_name === "preference")
              ?.delete
          )
        )
        : true,
  }
  // FIXED: Create group options for dropdown - Always ensure Unrecognized is available
  const groupOptions = groups
    .filter((g) => g.group_name !== "Unrecognized")
    .map((g) => ({ value: g.id, label: g.group_name }))
  const finalGroupOptions = [
    ...groupOptions,
    { label: "➕ Add new group", value: "__add_group__" },
  ]

  // Drag and drop sensors
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  )

  // API CALL: Fetch all field groups
  const {
    data: FieldGroup,
    error: groupError,
    refetch: fetchFieldGroup,
    isLoading: loadingGroups,
    isError: isGroupError,
  } = useGetRequest(
    `form/FetchFieldsGroups/${customerId}/${moduleType}`,
    `getFieldsGroup_${moduleType}`,
    headers,
    extras
  )

  // API CALL: Fetch all fields
  const {
    data: fieldData,
    error: fieldError,
    refetch: fetchField,
    isLoading: loadingFieldsAPI,
    isError: isFieldError,
  } = useGetRequest(
    `form/fetchAllFields/${customerId}/${moduleType}`,
    `getField_${moduleType}`,
    headers,
    extras
  )

  // FIXED: Initialize groups and ensure Unrecognized group exists
  useEffect(() => {
    if (FieldGroup?.status === "success") {
      const loadedGroups = FieldGroup.data || []
      setGroups(loadedGroups)
      // Auto-expand nested accordions for loaded groups only
      const groupKeys = loadedGroups.map((_, index) => `group-${index}`)
      setNestedAccordionKeys(groupKeys)
    } else if (isGroupError) {
      toast.error("Failed to fetch field groups")
      setGroups([])
    }
  }, [FieldGroup, isGroupError])

  // FIXED: Process field data and ensure ungrouped fields are handled
  useEffect(() => {
    if (fieldData?.status === "success") {
      processFieldData(fieldData.data)
    } else if (isFieldError) {
      toast.error("Failed to fetch fields")
    }
  }, [fieldData, isFieldError])

  // FIXED: Enhanced processFieldData to better handle ungrouped fields
  const processFieldData = (data) => {
    setLoadingFields(true)
    try {
      const processedFields = []
      const sequenceMap = {}

      // Process grouped fields
      if (data.grouped && Array.isArray(data.grouped)) {
        data.grouped.forEach((group) => {
          if (group.groupFields && Array.isArray(group.groupFields)) {
            group.groupFields.forEach((field, index) => {
              const fieldSequence = index + 1
              const processedField = {
                ...field,
                fieldName: field.label_name,
                fieldType: field.label_type,
                fieldGroup: group.group_name,
                groupId: group.id,
                icon: getFieldIcon(field.label_type),
                required: field.is_required === "yes",
                important: field.is_important === "yes",
                isCustom: true,
                options: field.option || [],
                sequence: fieldSequence,
              }
              processedFields.push(processedField)
              sequenceMap[field.id] = fieldSequence
            })
          }
        })
      }

      // FIXED: Process ungrouped fields and ensure they're visible
      if (data.ungrouped && Array.isArray(data.ungrouped)) {
        data.ungrouped.forEach((field, index) => {
          const fieldSequence = index + 1
          const processedField = {
            ...field,
            fieldName: field.label_name,
            fieldType: field.label_type,
            fieldGroup: "Unrecognized",
            groupId: "unrecognized",
            icon: getFieldIcon(field.label_type),
            required: field.is_required === "yes",
            important: field.is_important === "yes",
            isCustom: true,
            options: field.option || [],
            sequence: fieldSequence,
          }
          processedFields.push(processedField)
          sequenceMap[field.id] = fieldSequence
        })
      }

      setAllFields(processedFields)
      setFieldSequence(sequenceMap)
    } catch (err) {
      toast.error("Failed to process field data")
    } finally {
      setLoadingFields(false)
    }
  }

  // Enhanced option management functions
  const addOption = () => {
    const canModifyOptions = isEditMode
      ? preferenceGrant?.isEdit
      : preferenceGrant?.isCreate

    if (newOption.trim() && fieldOptions.length < 10) {
      const isDuplicate = fieldOptions.some(
        (opt) => opt.option.toLowerCase() === newOption.trim().toLowerCase()
      )
      if (!isDuplicate) {
        const newOptionObj = {
          option: newOption.trim(),
          sequence: (fieldOptions.length + 1).toString(),
        }
        setFieldOptions([...fieldOptions, newOptionObj])
        setNewOption("")
      } else {
        toast.error("Option already exists")
      }
    } else if (fieldOptions.length >= 10) {
      toast.error("Maximum 10 options allowed")
    }
  }

  const removeOption = (index) => {
    if (!preferenceGrant?.isEdit) {
      toast.warning("You are not authorized for this action!")
      return
    }
    const updatedOptions = fieldOptions.filter((_, i) => i !== index)
    const resequencedOptions = updatedOptions.map((opt, idx) => ({
      ...opt,
      sequence: (idx + 1).toString(),
    }))
    setFieldOptions(resequencedOptions)
  }

  const updateOption = (index, value) => {
    if (!preferenceGrant?.isEdit) {
      toast.warning("You are not authorized for this action!")
      return
    }
    const updatedOptions = [...fieldOptions]
    updatedOptions[index] = {
      ...updatedOptions[index],
      option: value,
    }
    setFieldOptions(updatedOptions)
  }

  const sortOptionsAlphabetically = () => {
    const sortedOptions = [...fieldOptions].sort((a, b) =>
      a.option.toLowerCase().localeCompare(b.option.toLowerCase())
    )
    const resequencedOptions = sortedOptions.map((opt, idx) => ({
      ...opt,
      sequence: (idx + 1).toString(),
    }))
    setFieldOptions(resequencedOptions)

    // toast.success("Options sorted alphabetically")
  }

  const handleOptionDragEnd = (event) => {
    const canModifyOptions = isEditMode
      ? preferenceGrant?.isEdit
      : preferenceGrant?.isCreate

    if (!canModifyOptions) return
    const { active, over } = event
    if (!over || active.id === over.id) return

    const activeIndex = Number.parseInt(
      active.id.toString().replace("option-", "")
    )
    const overIndex = Number.parseInt(over.id.toString().replace("option-", ""))

    if (activeIndex !== overIndex) {
      const newOptions = arrayMove(fieldOptions, activeIndex, overIndex)
      const resequencedOptions = newOptions.map((opt, idx) => ({
        ...opt,
        sequence: (idx + 1).toString(),
      }))
      setFieldOptions(resequencedOptions)
    }
  }

  // Utility functions
  const calculateDropSequence = (targetGroupName, overFieldId = null) => {
    const targetGroupFields = allFields.filter(
      (field) => field.fieldGroup === targetGroupName
    )
    if (overFieldId) {
      const overFieldIndex = targetGroupFields.findIndex(
        (field) => field.id === overFieldId
      )
      return overFieldIndex + 1
    }
    return targetGroupFields.length + 1
  }

  const getFieldsForGroup = (groupName) => {
    return allFields.filter((field) => field.fieldGroup === groupName)
  }

  const logQualityRules = (field, context = "render") => { }

  // FIXED: Complete form reset function
  const resetFormCompletely = () => {
    reset({
      fieldName: "",
      fieldType: "",
    })
    setSelectedGroup(null)
    setSelectedFieldTypeOption(null) // Reset React Select option
    setNewGroupName("")
    setIsAddingGroup(false)
    setRequired(false)
    setImportant(false)
    setEditingFieldIndex(null)
    setShowDescription(false)
    setDescription("")
    setFieldOptions([])
    setNewOption("")
    setSelectedFieldType("") // Reset field type
    setIsEditMode(false)
    setCustomizedFieldId("")
    setLoadingFieldDetails(false)
    setSequence("")
  }

  const handleModalClose = () => {
    resetFormCompletely()
    setShowModal(false)
  }

  // Recalculate sequences for fields in a group
  const recalculateGroupSequences = (groupName, updatedFields = allFields) => {
    const groupFields = updatedFields.filter(
      (field) => field.fieldGroup === groupName
    )
    const resequencedFields = groupFields.map((field, index) => ({
      ...field,
      sequence: index + 1,
    }))

    return resequencedFields
  }
  function normalizeOption(option) {
    try {
      let data = option

      // Keep parsing until actual array mil jaye
      while (typeof data === "string") {
        const parsed = JSON.parse(data)
        if (parsed === data) break
        data = parsed
      }
      return Array.isArray(data) ? data : []
    } catch {
      return []
    }
  }

  // Batch update function for sequence updates
  const batchUpdateFieldSequences = async (
    fieldsToUpdate,
    reason = "sequence update"
  ) => {
    if (!preferenceGrant?.isEdit) {
      toast.warning("You are not authorized for this action")
      return
    }
    const updatePromises = fieldsToUpdate.map(async (field, index) => {
      const payload = {
        customer_id: customerId,
        group_id: field.groupId === "unrecognized" ? null : field.groupId,
        module_name: moduleType,
        label_name: field.fieldName || field.label_name,
        label_type: field.fieldType || field.label_type,
        option: normalizeOption(field.options || field.option),
        is_required: field.required ? "yes" : field.is_required || "no",
        is_important: field.important ? "yes" : field.is_important || "no",
        user_login_id: loginUserId,
        sequence: field.sequence.toString(),
        description: field.description || null,
        customize_field_id: field.id,
      }

      try {
        const response = await PutRequest(
          `form/updateCustomerFields`,
          payload,
          { headers },
          extras
        )
        return {
          success: true,
          field: field.fieldName || field.label_name,
          response,
        }
      } catch (error) {
        return {
          success: false,
          field: field.fieldName || field.label_name,
          error,
        }
      }
    })

    try {
      const results = await Promise.all(updatePromises)
      const successful = results.filter((r) => r.success)
      const failed = results.filter((r) => !r.success)

      if (failed.length > 0) {
        toast.error(
          `Failed to update ${failed.length} field(s). Please try again.`
        )
      }
      return { successful, failed, totalUpdated: successful.length }
    } catch (error) {
      toast.error("Batch sequence update failed")
      return { successful: [], failed: fieldsToUpdate, totalUpdated: 0 }
    }
  }

  // FIXED: Enhanced drag end handler with better group resolution
  const handleDragEnd = async (event) => {
    if (!preferenceGrant?.isEdit) {
      toast.warning("You are not authorized for this action!")
      return
    }
    if (event.active.id.toString().startsWith("option-")) {
      handleOptionDragEnd(event)
      return
    }

    const { active, over } = event

    if (!over || active.id === over.id) return

    const activeField = allFields.find((field) => field.id === active.id)

    if (!activeField) return

    // Case 1: Dropping into an empty group area
    if (over.id.toString().startsWith("group-")) {
      const targetGroupName = over.id.toString().replace("group-", "")

      // FIXED: Better target group resolution
      let targetGroup = null
      let targetGroupId = null

      if (targetGroupName === "Unrecognized") {
        // Moving to Unrecognized group
        targetGroup = { id: "unrecognized", group_name: "Unrecognized" }
        targetGroupId = "unrecognized"
      } else {
        // Moving to a regular group - find it in the groups array
        targetGroup = groups.find(
          (group) => group.group_name === targetGroupName
        )
        if (targetGroup) {
          targetGroupId = targetGroup.id
        }
      }

      if (!targetGroup) {
        toast.error("Target group not found")
        return
      }

      const updatedFields = allFields.map((field) =>
        field.id === active.id
          ? {
            ...field,
            fieldGroup: targetGroup.group_name,
            groupId: targetGroupId,
            targetGroupDetails: targetGroup,
          }
          : field
      )

      let fieldsToUpdate = []

      if (activeField.fieldGroup !== targetGroupName) {
        const sourceGroupFields = recalculateGroupSequences(
          activeField.fieldGroup,
          updatedFields.filter((f) => f.id !== active.id)
        )
        const targetGroupFields = recalculateGroupSequences(
          targetGroupName,
          updatedFields
        )
        fieldsToUpdate = [...sourceGroupFields, ...targetGroupFields]
      } else {
        const targetGroupFields = recalculateGroupSequences(
          targetGroupName,
          updatedFields
        )
        fieldsToUpdate = targetGroupFields
      }

      setAllFields(updatedFields)

      const newSequenceMap = { ...fieldSequence }
      fieldsToUpdate.forEach((field) => {
        newSequenceMap[field.id] = field.sequence
      })

      setFieldSequence(newSequenceMap)

      const batchResult = await batchUpdateFieldSequences(
        fieldsToUpdate,
        `Group drop: ${activeField.fieldName || activeField.label_name
        } to ${targetGroupName}`
      )

      if (batchResult.totalUpdated > 0) {
        fetchField()
      }

      return
    }

    // Case 2: Dropping over another field (reordering)
    const overField = allFields.find((field) => field.id === over.id)
    if (overField) {
      const oldIndex = allFields.findIndex((field) => field.id === active.id)
      const newIndex = allFields.findIndex((field) => field.id === over.id)

      if (oldIndex !== -1 && newIndex !== -1) {
        const newFields = arrayMove(allFields, oldIndex, newIndex)
        let fieldsToUpdate = []

        if (activeField.fieldGroup !== overField.fieldGroup) {
          // FIXED: Better target group resolution for reordering
          let targetGroup = null
          let targetGroupId = null

          if (overField.fieldGroup === "Unrecognized") {
            targetGroup = { id: "unrecognized", group_name: "Unrecognized" }
            targetGroupId = "unrecognized"
          } else {
            targetGroup = groups.find(
              (group) => group.group_name === overField.fieldGroup
            )
            if (targetGroup) {
              targetGroupId = targetGroup.id
            }
          }

          if (targetGroup) {
            newFields[newIndex] = {
              ...newFields[newIndex],
              fieldGroup: overField.fieldGroup,
              groupId: targetGroupId,
              targetGroupDetails: targetGroup,
            }
          }

          const sourceGroupFields = recalculateGroupSequences(
            activeField.fieldGroup,
            newFields
          )
          const targetGroupFields = recalculateGroupSequences(
            overField.fieldGroup,
            newFields
          )
          fieldsToUpdate = [...sourceGroupFields, ...targetGroupFields]
        } else {
          const groupFields = recalculateGroupSequences(
            activeField.fieldGroup,
            newFields
          )
          fieldsToUpdate = groupFields
        }

        setAllFields(newFields)

        const newSequenceMap = { ...fieldSequence }
        fieldsToUpdate.forEach((field) => {
          newSequenceMap[field.id] = field.sequence
        })
        setFieldSequence(newSequenceMap)

        const batchResult = await batchUpdateFieldSequences(
          fieldsToUpdate,
          `Field reorder: ${activeField.fieldName || activeField.label_name
          } over ${overField.fieldName || overField.label_name}`
        )

        if (batchResult.totalUpdated > 0) {
          fetchField()
        }
      }
    }
  }

  // Form submission handler
  const { mutate: addCustomField } = usePostRequest(
    `form/createCustomFields`,
    null,
    { headers },
    extras
  )

  // FIXED: Enhanced form submission with better ungrouped field handling
  const onSubmit = async (data) => {
    // Validate options for Single/Multiple option fields
    if (
      (selectedFieldType === "single-option" ||
        selectedFieldType === "multiple-option") &&
      fieldOptions.length === 0
    ) {
      toast.error("Please add at least one option for this field type")
      return
    }

    // FIXED: Better group handling - explicitly handle ungrouped fields
    let groupId = null
    let groupName = "Unrecognized"

    if (selectedGroup?.value === "__add_group__") {
      // Creating new group
      groupName = newGroupName.trim()
      groupId = newGroupName.trim()
    } else if (
      selectedGroup?.value &&
      selectedGroup.value !== "__add_group__"
    ) {
      // Existing group selected
      groupId = selectedGroup.value
      groupName = selectedGroup.label
    }
    // If selectedGroup is null/empty, it stays as null/Unrecognized

    // Handle options properly
    let optionsToSend = null
    if (
      selectedFieldType === "single-option" ||
      selectedFieldType === "multiple-option"
    ) {
      optionsToSend = fieldOptions.length > 0 ? fieldOptions : null
    }

    const payload = {
      customer_id: customerId,
      group_id: groupId, // null for ungrouped fields
      module_name: moduleType,
      label_name: data.fieldName,
      label_type: selectedFieldType, // Use selectedFieldType instead of data.fieldType
      option: optionsToSend,
      is_required: required ? "yes" : "no",
      is_important: important ? "yes" : "no",
      user_login_id: loginUserId,
      description:
        description && description.trim() !== "" ? description.trim() : null,
    }

    try {
      if (isEditMode && customizedFieldId) {
        // UPDATE EXISTING FIELD
        const updatePayload = {
          ...payload,
          customize_field_id: customizedFieldId,
          sequence: sequence,
        }

        try {
          const response = await PutRequest(
            `form/updateCustomerFields`,
            updatePayload,
            { headers },
            extras
          )

          if (response && response.status === "success") {
            toast.success(response.message || "Field updated successfully")
            fetchField()
            fetchFieldGroup()
            resetFormCompletely()
            setShowModal(false)
          } else if (response && response.status === "fail") {
            toast.warning(response.message)
          } else {
            toast.error(response?.message || "Failed to update field")
          }
        } catch (updateError) {
          toast.error("Failed to update field")
        }
      } else {
        // ADD NEW CUSTOM FIELD
        addCustomField(payload, {
          onSuccess: (res) => {
            if (res?.status === "success") {
              toast.success(res.message || "Field added successfully")
              fetchField()
              fetchFieldGroup()
              resetFormCompletely()
              setShowModal(false)
            } else {
              toast.error(res.message || "Failed to add field")
            }
          },
          onError: (err) => {
            toast.error(err?.message || "Add field request failed")
          },
        })
      }
    } catch (error) {
      toast.error("An error occurred while saving the field")
    }
  }

  // Get field icon based on type
  const getFieldIcon = (fieldType) => {
    switch (fieldType) {
      case "Text":
        return "abc"
      case "largeText":
        return "abc"
      case "Single-Option":
        return "🔽"
      case "Multiple-Option":
        return "🔽"
      case "Numerical":
      case "Number":
        return "$$"
      case "Monetary":
        return "$$"
      case "Organization":
        return "🏢"
      case "person":
        return "👤"
      case "phone":
        return "📞"
      case "time":
      case "time-range":
        return "🕐"
      case "date":
      case "date range":
        return "📅"
      case "address":
        return "📍"
      case "user":
        return "👥"
      case "AutoComplete":
        return "🔍"
      default:
        return "🛠️"
    }
  }

  // Handle group selection in dropdown
  const handleGroupChange = (selected) => {
    setSelectedGroup(selected)
    if (selected?.value === "__add_group__") {
      setIsAddingGroup(true)
    } else {
      setIsAddingGroup(false)
    }
  }



  // FIXED: Enhanced edit field handling with proper option parsing and field type setting
  const handleEditField = async (field, index) => {
    if (!preferenceGrant?.isEdit) {
      toast.warning("You are not authorized for this action")
      return
    }
    setLoadingFieldDetails(true)

    const fieldSequenceNumber =
      fieldSequence[field.id] || field.sequence || index + 1

    setSequence(fieldSequenceNumber)

    try {
      const response = await GetRequest(
        `form/getDetailsOfCustomerFields/${field.id}/${customerId}`,
        { headers },
        extras
      )

      if (response && response.status === "success" && response.data) {
        const fieldDetails = response.data

        setIsEditMode(true)
        setCustomizedFieldId(field.id)
        setEditingFieldIndex(index)

        // ✅ POPULATE FORM: Field Name and Type
        reset({
          fieldName:
            fieldDetails.label_name || field.fieldName || field.label_name,
          fieldType:
            fieldDetails.label_type || field.fieldType || field.label_type,
        })

        // ✅ POPULATE FORM: Group Selection
        setSelectedGroup(
          field.fieldGroup && field.fieldGroup !== "Unrecognized"
            ? {
              value: field.groupId || field.fieldGroup,
              label: field.fieldGroup,
            }
            : null
        )

        // ✅ POPULATE FORM: Quality Rules
        setRequired(field.required || fieldDetails.is_required === "yes")
        setImportant(field.important || fieldDetails.is_important === "yes")

        // ✅ POPULATE FORM: Description
        const fieldDescription =
          fieldDetails.description || field.description || ""
        setDescription(fieldDescription)
        setShowDescription(!!fieldDescription)

        // POPULATE FORM: Field Options - Handle multiple levels of JSON escaping
        let parsedOptions = []
        try {
          if (fieldDetails[0]?.option) {
            let data = fieldDetails[0].option

            // Handle multiple levels of JSON string escaping
            while (typeof data === "string") {
              try {
                data = JSON.parse(data)
              } catch (innerParseError) {
                break
              }
            }

            if (Array.isArray(data)) {
              parsedOptions = data
            } else {
              parsedOptions = []
            }
          }
        } catch (parseError) {
          parsedOptions = []
        }

        setFieldOptions(parsedOptions)

        // ✅ POPULATE FORM: Field Type (CRITICAL - this makes options section visible)
        const fieldType =
          fieldDetails.label_type || field.fieldType || field.label_type
        setSelectedFieldType(fieldType)
        // FIXED: Set the React Select option properly for edit mode
        const fieldTypeOption =
          fieldTypes.find((type) => type.value === fieldType) || null
        setSelectedFieldTypeOption(fieldTypeOption)

        // Open modal
        setShowModal(true)
      } else {
        toast.error("Failed to fetch field details")
      }
    } catch (error) {
      toast.error("Error fetching field details")
    } finally {
      setLoadingFieldDetails(false)
    }
  }

  // Delete field handler
  const handleDeleteField = async (field) => {
    if (!preferenceGrant?.isDelete) {
      toast.warning("You are not authorized for this action!")
      return
    }
    if (!field.id) return
    setFieldToDelete(field.id)
    setShowDeleteModal(true)
  }

  const handleConfirmedDelete = async () => {
    setIsLoading(true)
    try {
      const response = await DeleteRequest(
        `form/deleteCustomField/${FieldToDelete}/${customerId}`,
        { headers },
        extras
      )
      setShowDeleteModal(false)

      if (response && response.status === "success") {
        toast.success("Field deleted successfully")
        setAllFields((prevFields) => {
          const updatedFields = prevFields.filter(
            (field) => field.id !== FieldToDelete
          )
          return updatedFields
        })

        setFieldSequence((prevSequence) => {
          const updatedSequence = { ...prevSequence }
          delete updatedSequence[FieldToDelete]
          return updatedSequence
        })
        setIsLoading(false)
        fetchField()
      } else {
        toast.error(response?.message || "Failed to delete field")
        setIsLoading(false)

      }
    } catch (error) {
      toast.error("An error occurred while deleting the field")
      setIsLoading(false)

    }
  }

  // Create new group
  const { mutate: addFieldGroup } = usePostRequest(
    `form/createFieldGroup`,
    null,
    { headers },
    extras
  )

  const handleAddNewGroup = () => {
    if (!preferenceGrant?.isCreate) {
      toast.warning("You are not authorized for this action!")
      return
    }
    if (newGroupName.trim()) {
      const payload = {
        group_name: newGroupName.trim(),
        customer_id: customerId,
        User_login_id: loginUserId,
        module_name: moduleType,
      }

      addFieldGroup(payload, {
        onSuccess: (res) => {
          if (res?.status === "success") {
            toast.success(res.message)

            const newGroup = {
              id: res.data || newGroupName.trim(),
              group_name: newGroupName.trim(),
            }

            setGroups((prevGroups) => [...prevGroups, newGroup])
            setSelectedGroup({
              value: newGroup.id,
              label: newGroupName.trim(),
            })

            setIsAddingGroup(false)
            setNewGroupName("")
            fetchFieldGroup()
          } else {
            toast.error(res.message)
          }
        },
        onError: (error) => {
          toast.error("Failed to create group")
        },
      })
    }
  }

  // Edit group name
  const handleGroupEdit = (group) => {
    setEditingGroup(group)
    setEditedName(group.group_name)
  }

  // Delete group
  const handleDeleteGroup = async (group) => {
    if (group.group_name === "Unrecognized") {
      toast.error("Cannot delete the Unrecognized group")
      return
    }

    setGroupToDelete(group.id)
    setShowDeleteModal1(true)
  }

  const handleConfirmedDeleteGroup = async () => {
    try {
      const response = await DeleteRequest(
        `/form/deleteFieldGroup/${GroupToDelete}/${customerId}`,
        { headers },
        extras
      )
      setShowDeleteModal1(false)

      if (response && response.status === "success") {
        toast.success(response.message)

        setGroups((prevGroups) => {
          const updatedGroups = prevGroups.filter(
            (group) => group.id !== GroupToDelete
          )
          return updatedGroups
        })

        setAllFields((prevFields) => {
          const updatedFields = prevFields.map((field) => {
            const deletedGroup = groups.find((g) => g.id === GroupToDelete)
            if (deletedGroup && field.fieldGroup === deletedGroup.group_name) {
              return {
                ...field,
                fieldGroup: "Unrecognized",
                groupId: "unrecognized",
              }
            }
            return field
          })
          return updatedFields
        })
        setIsLoading(false)
        fetchFieldGroup()
        fetchField()
      } else {
        toast.error(response?.message || "Failed to delete group")
        setIsLoading(false)

      }
    } catch (error) {
      toast.error("An error occurred while deleting the group")
      setIsLoading(false)

    }
  }

  // Save edited group
  const saveEditedGroup = async () => {
    if (editingGroup.group_name === "Unrecognized") {
      toast.error("Cannot edit the Unrecognized group")
      setEditingGroup(null)
      return
    }

    const payload = {
      customer_id: customerId,
      group_name: editedName,
      group_id: editingGroup.id,
      module_name: moduleType,
    }

    try {
      const response = await PutRequest(
        `form/updateFieldGroup/`,
        payload,
        { headers },
        extras
      )
      if (response && response.status === "success") {
        toast.success("Group updated successfully")
        fetchFieldGroup()
        fetchField()
      } else {
        toast.error(response?.message || "Failed to update group")
      }
    } catch (error) {
      toast.error("An error occurred while updating the group")
    }

    setEditingGroup(null)
  }

  // FIXED: Toggle all accordions - Updated to handle new group visibility logic
  const toggleAllAccordions = (expand = true) => {
    if (expand) {
      setActiveAccordionKeys(["0", "1", "2"])
      const ungroupedFields = getFieldsForGroup("Unrecognized").filter(
        (field) => field.isCustom
      )
      const displayGroups = [...groups]
      if (ungroupedFields.length > 0) {
        displayGroups.push({ id: "unrecognized", group_name: "Unrecognized" })
      }
      const allGroupKeys = displayGroups.map((_, index) => `group-${index}`)
      setNestedAccordionKeys(allGroupKeys)
    } else {
      setActiveAccordionKeys([])
      setNestedAccordionKeys([])
    }
  }

  // Handle main accordion selection change
  const handleAccordionSelect = (eventKeys) => {
    setActiveAccordionKeys(eventKeys || [])
  }

  // Handle nested accordion selection change
  const handleNestedAccordionSelect = (eventKeys) => {
    setNestedAccordionKeys(eventKeys || [])
  }

  // Get all custom fields (for flat view)
  const getAllCustomFields = () => {
    return allFields.filter((field) => field.isCustom)
  }

  // FIXED: Enhanced render options section with proper array validation
  const renderOptionsSection = () => {
    if (
      selectedFieldType === "single-option" ||
      selectedFieldType === "multiple-option"
    ) {
      // Ensure fieldOptions is always an array before rendering
      const safeFieldOptions = Array.isArray(fieldOptions) ? fieldOptions : []

      return (
        <Form.Group className="mb-3 ">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span
              style={{
                fontWeight: "400",
                fontSize: "0.86rem",
                color: "#878b8e",
              }}
            >
              options <span className="text-danger">*</span>
            </span>
            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={sortOptionsAlphabetically}
                disabled={safeFieldOptions.length === 0}
                title="Sort A-Z"
              >
                <FaSortAlphaDown />
              </Button>
              <small className="text-muted align-self-center">
                {safeFieldOptions.length}/10
              </small>
            </div>
          </div>

          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <div className="mb-2">
              <SortableContext
                items={safeFieldOptions.map((_, index) => `option-${index}`)}
                strategy={verticalListSortingStrategy}
              >
                {safeFieldOptions.map((option, index) => (
                  <DraggableOptionItem
                    key={`option-${index}`}
                    option={option}
                    index={index}
                    onUpdate={updateOption}
                    onRemove={removeOption}
                    fieldType={selectedFieldType}
                  />
                ))}
              </SortableContext>
              {/* Add new option input */}
              <div className="d-flex gap-2 align-items-center">
                <div style={{ width: "24px" }}></div>
                {selectedFieldType === "multiple-option" && (
                  <span className="text-muted" style={{ minWidth: "20px" }}>
                    =
                  </span>
                )}
                <Form.Control
                  type="text"
                  className="form-control custom-min-height"
                  value={newOption}
                  onChange={(e) => setNewOption(e.target.value)}
                  placeholder="Add new option"
                  disabled={safeFieldOptions.length >= 10}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault()
                      addOption()
                    }
                  }}
                />
                <Button
                  variant="outline-primary"
                  onClick={addOption}
                  disabled={safeFieldOptions.length >= 10 || !newOption.trim()}
                >
                  <FaPlus />
                </Button>
              </div>
            </div>
          </DndContext>
        </Form.Group>
      )
    }
    return null
  }

  return (
    <>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <div className="pt-3">
          <DeleteModal
            show={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            isLoading={isLoading}
            onConfirm={() =>
              handleConfirmedDelete(FieldToDelete) ||
              handleConfirmedDeleteGroup(GroupToDelete)
            }
            message="Are you sure you want to permanently delete this item?"

          />
          <DeleteModal />
          <DeleteModal
            show={showDeleteModal1}
            onClose={() => setShowDeleteModal1(false)}
            onConfirm={() => handleConfirmedDeleteGroup(GroupToDelete)}
            isLoading={isLoading}
            message="Are you sure you want to permanently delete this item?"

          />

          {/* Header with action buttons */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-2">
              <Button
                className="btn btn-default"
                onClick={() => {
                  if (!preferenceGrant?.isCreate) {
                    toast.warning("You are not authorized for this action!")
                    return
                  }
                  setShowModal(true)
                }}
              >
                + Custom field
              </Button>
            </div>
            <div className="d-flex gap-2">
              <Button
                className="btn btn-default-outline"
                onClick={() => toggleAllAccordions(true)}
              >
                Expand All
              </Button>
              <Button
                className="btn btn-default-outline"
                onClick={() => toggleAllAccordions(false)}
              >
                Collapse All
              </Button>
              <Button
                className="btn btn-default-outline"
                onClick={() =>
                  setViewMode(viewMode === "flat" ? "grouped" : "flat")
                }
              >
                {viewMode === "flat" ? "Group View" : "Field View"}
                {/* {viewMode === "flat" ? "Group View" : "Field View"} */}
              </Button>
            </div>
          </div>

          {/* Main accordion with controlled state */}
          <Accordion
            className="mb-5 custom-field-accordion"
            activeKey={activeAccordionKeys}
            onSelect={handleAccordionSelect}
            alwaysOpen
          >
            {/* Custom Fields Section */}
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <div className="d-flex align-items-center gap-2">
                  📄 Custom fields
                  <Badge bg="secondary">{getAllCustomFields().length}</Badge>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                {loadingGroups || loadingFields || loadingFieldsAPI ? (
                  <div className="text-center py-3">Loading...</div>
                ) : getAllCustomFields().length === 0 ? (
                  <p className="text-muted">No custom fields yet.</p>
                ) : viewMode === "flat" ? (
                  // Flat view - all fields in one table
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <table className="table table-hover">
                      <thead className="customField">
                        <tr>
                          <th style={{ width: "30px" }}></th>
                          <th className="fw-semibold">Field name</th>
                          <th className="text-center">Description</th>
                          {/* <th className="text-end">
                          <span className="text-muted me-3">Quality rules</span>
                          <span className="text-muted">⚙ Edit</span>
                          
                        </th> */}
                          <th className="text-center">
                            <span className="text-muted">⭐ Quality rules</span>
                          </th>
                          <th className="text-end">
                            <span className="text-muted">⚙ Edit</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <SortableContext
                          items={getAllCustomFields().map((field) => field.id)}
                          strategy={verticalListSortingStrategy}
                        >
                          {getAllCustomFields().map((field, idx) => (
                            <DraggableTableRow
                              key={field.id}
                              field={field}
                              index={idx}
                              onEditField={handleEditField}
                              onDeleteField={handleDeleteField}
                              allFields={allFields}
                              canDrag={preferenceGrant?.isEdit}
                            />
                          ))}
                        </SortableContext>
                      </tbody>
                    </table>
                  </div>
                ) : (
                  // FIXED: Grouped view with proper visibility logic
                  <Accordion
                    className="custom-field-accordion"
                    activeKey={nestedAccordionKeys}
                    onSelect={handleNestedAccordionSelect}
                    alwaysOpen
                  >
                    {(() => {
                      // FIXED: Create a combined list of groups to display
                      const ungroupedFields = getFieldsForGroup(
                        "Unrecognized"
                      ).filter((field) => field.isCustom)
                      const displayGroups = [...groups]
                      // Only add Unrecognized to display if it has fields
                      if (ungroupedFields.length > 0) {
                        displayGroups.push({
                          id: "unrecognized",
                          group_name: "Unrecognized",
                        })
                      }

                      return displayGroups.map((group, idx) => {
                        const groupFields = getFieldsForGroup(group.group_name)
                        const customGroupFields = groupFields.filter(
                          (field) => field.isCustom
                        )

                        return (
                          <Accordion.Item
                            eventKey={`group-${idx}`}
                            key={group.id || group.group_name}
                          >
                            <Accordion.Header>
                              <div className="d-flex justify-content-between w-100 align-items-center">
                                <div className="text-capitalize">
                                  {group.group_name}
                                  {group.group_name === "Unrecognized" && (
                                    <small className="text-muted ms-2">
                                      (Fields without groups)
                                    </small>
                                  )}
                                </div>
                                <div
                                  className="d-flex align-items-center gap-2"
                                  // Move stopPropagation here to a wrapper
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <Badge bg="secondary">
                                    {customGroupFields.length}
                                  </Badge>
                                  {group.group_name !== "Unrecognized" && (
                                    <Dropdown
                                      align="end"
                                      show={openGroupDropdown === group.id}
                                      onToggle={(isOpen) => {
                                        if (isOpen) {
                                          // Collapse the current group when dropdown opens
                                          const currentGroupKey = `group-${idx}`
                                          const updatedKeys =
                                            nestedAccordionKeys.filter(
                                              (key) => key !== currentGroupKey
                                            )
                                          setNestedAccordionKeys(updatedKeys)
                                          setOpenGroupDropdown(group.id)
                                        } else {
                                          setOpenGroupDropdown(null)
                                        }
                                      }}
                                    >
                                      <Dropdown.Toggle
                                        as="span"
                                        className="text-muted"
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "10px",
                                          position: "relative",
                                          // zIndex: 1051, // Higher than sticky header
                                        }}
                                        bsPrefix="p-0 border-0 bg-transparent"
                                      >
                                        <BsThreeDotsVertical />
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu
                                        className="custom-dropdown-menu" // Add your CSS class here
                                        style={{
                                          zIndex: 9999, // Even higher z-index for the menu
                                          position: "absolute",
                                          // right: 0,
                                          // top: "100%",
                                        }}
                                        /* This ensures the menu isn't cut off by parent containers */
                                        popperConfig={{
                                          modifiers: [
                                            {
                                              name: "preventOverflow",
                                              options: {
                                                boundary: "viewport",
                                              },
                                            },
                                          ],
                                        }}
                                      >
                                        <Dropdown.Item
                                          onClick={() => {
                                            if (!preferenceGrant?.isEdit) {
                                              toast.warning(
                                                "You are not authorized for this action!"
                                              )
                                              return
                                            }
                                            handleGroupEdit(group)
                                            setOpenGroupDropdown(null)
                                          }}
                                        >
                                          Edit Group Name
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          onClick={() => {
                                            if (!preferenceGrant?.isDelete) {
                                              toast.warning(
                                                "You are not authorized for this action!"
                                              )
                                              return
                                            }
                                            handleDeleteGroup(group)
                                            setOpenGroupDropdown(null)
                                          }}
                                        >
                                          Delete Group
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}
                                </div>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              <DroppableGroupArea groupName={group.group_name}>
                                {loadingFields || loadingFieldsAPI ? (
                                  <div className="text-center py-3">
                                    Loading fields...
                                  </div>
                                ) : customGroupFields.length > 0 ? (
                                  <div
                                    style={{
                                      maxHeight: "400px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    <table className="table table-hover">
                                      <thead className="customField">
                                        <tr>
                                          <th style={{ width: "30px" }}></th>
                                          <th className="fw-semibold">
                                            Field name
                                          </th>
                                          <th className="text-center">
                                            Description
                                          </th>
                                          <th className="text-center">
                                            <span className="text-muted">
                                              ⭐ Quality rules
                                            </span>
                                          </th>
                                          <th className="text-end">
                                            <span className="text-muted">
                                              ⚙ Edit
                                            </span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <SortableContext
                                          items={customGroupFields.map(
                                            (field) => field.id
                                          )}
                                          strategy={verticalListSortingStrategy}
                                        >
                                          {customGroupFields.map(
                                            (field, idx2) => (
                                              <DraggableGroupRow
                                                key={field.id}
                                                field={field}
                                                index={idx2}
                                                onEditField={handleEditField}
                                                onDeleteField={
                                                  handleDeleteField
                                                }
                                                canDrag={
                                                  preferenceGrant?.isEdit
                                                }
                                                allFields={allFields}
                                                logQualityRules={
                                                  logQualityRules
                                                }
                                              />
                                            )
                                          )}
                                        </SortableContext>
                                      </tbody>
                                    </table>
                                  </div>
                                ) : null}
                              </DroppableGroupArea>
                            </Accordion.Body>
                          </Accordion.Item>
                        )
                      })
                    })()}
                  </Accordion>
                )}
              </Accordion.Body>
            </Accordion.Item>

            {/* Default Fields Section */}
            <Accordion.Item eventKey="1">
              <Accordion.Header>📦 Default fields</Accordion.Header>
              <Accordion.Body>
                <div style={{ overflowY: "none" }}>
                  <table className="table table-hover">
                    <thead className="customField">
                      <tr>
                        <th className="fw-semibold">Field name</th>
                        <th className="text-start">description</th>
                        <th className="text-center">important</th>
                        <th className="text-center">required</th>
                      </tr>
                    </thead>
                    <tbody>
                      {defaultFields.map((field, index) => (
                        <tr key={index}>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <span
                                className="px-2 py-1 border rounded bg-light text-muted"
                                style={{
                                  fontSize: "0.8rem",
                                  minWidth: "32px",
                                  textAlign: "center",
                                }}
                              >
                                {field.icon || "🔧"}
                              </span>
                              <div>
                                <div>{field.name}</div>
                                <div className="text-muted small">
                                  {field.type}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="text-start">{field.description}</td>
                          <td className="text-center">{field.imp}</td>
                          <td className="text-center">{field.req}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* Add/Edit Field Modal */}
          <Modal show={showModal} onHide={handleModalClose} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditMode ? "Edit field" : "Add contact field"}
                {loadingFieldDetails && (
                  <span className="ms-2 text-muted">(Loading...)</span>
                )}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form
                onSubmit={handleSubmit(onSubmit)}
                className="form-container"
              >
                <div className="d-flex justify-content-between gap-3">
                  <div style={{ width: "55%" }}>
                    <Col md={12}>
                      {/* Field Name Input */}
                      <Form.Group className="mb-3 focus-z-index position-relative">
                        <Form.Label>
                          Field name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter field name"
                          {...register("fieldName", { required: true })}
                          disabled={loadingFieldDetails}
                        />
                        {errors.fieldName && (
                          <Form.Text className="text-danger">
                            Field name is required
                          </Form.Text>
                        )}
                      </Form.Group>

                      {/* FIXED: Group Selection - Better handling of ungrouped fields */}
                      <Form.Group className="mb-3 focus-z-index position-relative">
                        <Form.Label>Field group</Form.Label>
                        <Select
                          value={selectedGroup}
                          onChange={handleGroupChange}
                          options={finalGroupOptions}
                          styles={customStyles}
                          classNamePrefix="react-select"
                          isClearable
                          placeholder={
                            loadingGroups
                              ? "Loading groups..."
                              : "Select group (leave empty for ungrouped)"
                          }
                          isLoading={loadingGroups || loadingFieldDetails}
                          isDisabled={loadingGroups || loadingFieldDetails}
                        />
                        <Form.Text className="text-muted">
                          Leave empty to add field to "Unrecognized" group
                        </Form.Text>
                      </Form.Group>

                      {/* New Group Input Modal */}
                      <Modal
                        style={{ backdropFilter: "blur(2px)" }}
                        show={isAddingGroup}
                        onHide={() => {
                          setIsAddingGroup(false)
                          setNewGroupName("")
                          setSelectedGroup(null)
                        }}
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Add New Field Group</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form.Group className="mb-3 focus-z-index position-relative">
                            <Form.Label>Group Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter new group name"
                              value={newGroupName}
                              onChange={(e) => setNewGroupName(e.target.value)}
                              autoFocus
                              disabled={loadingFieldDetails}
                            />
                          </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            className="btn btn-default"
                            onClick={() => {
                              setIsAddingGroup(false)
                              setNewGroupName("")
                              setSelectedGroup(null)
                            }}
                            disabled={loadingFieldDetails}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="success"
                            onClick={handleAddNewGroup}
                            disabled={
                              !newGroupName.trim() || loadingFieldDetails
                            }
                          >
                            Create
                          </Button>
                        </Modal.Footer>
                      </Modal>

                      {/* Field Type Selection - FIXED: Using React Select */}
                      <Form.Group className="mb-3 focus-z-index position-relative">
                        <Form.Label>
                          Field type <span className="text-danger">*</span>
                        </Form.Label>
                        <Select
                          value={selectedFieldTypeOption}
                          onChange={(selected) => {
                            setSelectedFieldTypeOption(selected)
                            setValue("fieldType", selected?.value || "")
                            setSelectedFieldType(selected?.value || "")
                          }}
                          styles={customStyles}
                          classNamePrefix="react-select"
                          options={fieldTypes}
                          isClearable
                          placeholder="Select field type"
                          isDisabled={loadingFieldDetails}
                        />
                        {errors.fieldType && (
                          <Form.Text className="text-danger">
                            Field type is required
                          </Form.Text>
                        )}
                      </Form.Group>

                      {/* Options Section */}
                      {renderOptionsSection()}

                      {/* Description Section */}
                      {isEditMode && (
                        <Form.Group className="mb-3 focus-z-index position-relative">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            {/* <div className="d-flex justify-content-between w-100 "> */}
                            <Form.Label className="form-container customField-description-margin ">
                              Description
                            </Form.Label>
                            {!showDescription && (
                              <div style={{ marginLeft: "300px" }}>
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  onClick={() => setShowDescription(true)}
                                  disabled={loadingFieldDetails}
                                >
                                  + Add Description
                                </Button>
                              </div>
                            )}
                            {/* </div> */}
                          </div>
                          {showDescription && (
                            <div>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter field description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loadingFieldDetails}
                              />
                              <div className="mt-2">
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  onClick={() => {
                                    setShowDescription(false)
                                    setDescription("")
                                  }}
                                  disabled={loadingFieldDetails}
                                >
                                  Remove Description
                                </Button>
                              </div>
                            </div>
                          )}
                        </Form.Group>
                      )}
                    </Col>
                  </div>

                  <div style={{ width: "40%" }}>
                    <Form.Group className="mb-3 ">
                      {/* <Form.Label>Quality rules</Form.Label> */}
                      <p
                        className="mb-2 mt-0"
                        style={{
                          fontWeight: "400",
                          fontSize: "0.86rem",
                          color: "#878b8e",
                        }}
                      >
                        Quality Rules
                      </p>
                      <div className="d-flex flex-column gap-2">
                        <div className="d-flex ">
                          <Form.Check
                            type="switch"
                            checked={required}
                            onChange={() => setRequired(!required)}
                          />
                          <span
                            style={{
                              fontWeight: "400",
                              fontSize: "0.86rem",
                              color: "#878b8e",
                            }}
                          >
                            Required
                          </span>
                        </div>
                        <div className="d-flex ">
                          <Form.Check
                            type="switch"
                            checked={important}
                            onChange={() => setImportant(!important)}
                          />
                          <span
                            style={{
                              fontWeight: "400",
                              fontSize: "0.86rem",
                              color: "#878b8e",
                            }}
                          >
                            Important
                          </span>
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                </div>

                <div className="d-flex justify-content-end pt-3">
                  <button
                    onClick={handleModalClose}
                    className="me-2 btn btn-default-outline btn btn-custom-variant"
                    disabled={loadingFieldDetails}
                  >
                    Cancel
                  </button>
                  <Button
                    type="submit"
                    className="btn btn-default"
                    disabled={loadingFieldDetails}
                  >
                    {loadingFieldDetails
                      ? "Loading..."
                      : isEditMode
                        ? "Update"
                        : "Save"}
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Edit Group Name Modal */}
          <Modal show={!!editingGroup} onHide={() => setEditingGroup(null)}>
            <Modal.Header closeButton>
              <Modal.Title>Edit Group Name</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Label className="w-auto">Group Name</Form.Label>
                <Form.Control
                  type="text"
                  value={editedName}
                  onChange={(e) => setEditedName(e.target.value)}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-default-outline btn btn-custom-variant"
                onClick={() => setEditingGroup(null)}
              >
                Cancel
              </button>
              <Button className="btn btn-default" onClick={saveEditedGroup}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </DndContext>
      <style jsx>{`
        .custom-field-accordion .accordion-button:not(.collapsed) {
          background-color: var(--bs-accordion-active-bg);
          box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0
            var(--bs-accordion-border-color);
          color: var(--bs-accordion-active-color);
        }

        .custom-field-accordion .accordion-button:focus {
          border-color: var(--primary03);
          box-shadow: none;
        }

        .custom-field-accordion .accordion-button::after {
          font-family: remixicon !important;
          font-size: 0.8rem;
          line-height: 1;
          background-color: transparent !important;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 3.125rem;
          color: var(--default-text-color);
        }

        /* Add this to your stylesheet */
        .custom-dropdown-menu {
          z-index: 9999 !important; /* Extremely high to clear all UI elements */
        }

        .custom-dropdown-menu:hover {
          z-index: 10000 !important;
        }
      `}</style>
    </>
  )
}

export default ContactFields
